import { Link } from "react-router-dom";
import BlogPostLayout from "./BlogPostLayout";
import { getPostBySlug } from "../../lib/blog";

export default function CreditImpotJardin() {
  const post = getPostBySlug("credit-impot-50-entretien-jardin");
  return (
    <BlogPostLayout post={post}>
      <p>
        Beaucoup de propriétaires en Creuse l'ignorent encore : faire entretenir
        son jardin par un professionnel agréé peut vous{" "}
        <strong>rembourser 50 % du montant payé</strong> sous forme de crédit
        d'impôt. Et depuis 2022, ce dispositif est même devenu{" "}
        <strong>immédiat</strong> grâce à l'avance URSSAF. On vous explique
        comment en bénéficier en 2026.
      </p>

      <h2>Qui peut bénéficier du crédit d'impôt ?</h2>
      <p>
        Toute personne <strong>domiciliée fiscalement en France</strong> qui
        fait appel à un prestataire <strong>agréé « services à la personne »</strong>{" "}
        pour de petits travaux d'entretien de jardin. Ce crédit est accessible
        que vous soyez imposable ou non, et que vous soyez propriétaire ou
        locataire.
      </p>

      <h2>Quels travaux sont éligibles ?</h2>
      <p>
        L'éligibilité concerne les <strong>petits travaux de jardinage</strong>{" "}
        d'entretien courant — pas les créations paysagères lourdes. Sont
        notamment concernés :
      </p>
      <ul>
        <li><strong>Tonte de pelouse</strong> et entretien régulier</li>
        <li><strong>Taille de haies et arbustes</strong> de moins de 4 m</li>
        <li><strong>Désherbage</strong> manuel ou mécanique</li>
        <li><strong>Débroussaillage léger</strong> de jardin d'agrément</li>
        <li><strong>Ramassage de feuilles</strong>, nettoyage d'allées</li>
        <li><strong>Enlèvement de déchets verts</strong> issus de la prestation</li>
      </ul>

      <div className="callout-warn">
        <strong>Attention aux travaux non éligibles</strong>
        L'élagage en hauteur, l'abattage, la création d'un jardin, le terrassement
        ou les travaux de maçonnerie paysagère <strong>ne sont pas éligibles</strong>{" "}
        au crédit d'impôt services à la personne.
      </div>

      <h2>Quel est le plafond ?</h2>
      <p>
        Le plafond annuel pour les <strong>petits travaux de jardinage</strong>{" "}
        est de <strong>5 000 € par foyer fiscal</strong>, soit un avantage
        maximal de <strong>2 500 € par an</strong>. Ce plafond s'ajoute aux
        autres prestations « services à la personne » (ménage, garde d'enfants…)
        dans la limite globale de 12 000 € à 20 000 € selon votre situation.
      </p>

      <h2>L'avance immédiate URSSAF : comment ça marche ?</h2>
      <p>
        Depuis juin 2022, le dispositif{" "}
        <strong>« Avance immédiate »</strong> permet de ne payer que la moitié
        de la facture, l'URSSAF prenant directement en charge le crédit d'impôt
        sans attendre la déclaration. Plus besoin de patienter un an !
      </p>
      <ol>
        <li>
          Votre prestataire (comme K'REUSE EXTÉRIEUR) doit être agréé{" "}
          <strong>SAP</strong> et inscrit au dispositif.
        </li>
        <li>
          Vous créez un compte sur{" "}
          <a
            href="https://www.urssaf.fr/portail/home/services-a-la-personne.html"
            target="_blank"
            rel="noopener noreferrer"
          >
            urssaf.fr / services à la personne
          </a>
          .
        </li>
        <li>
          Vous reliez votre dossier au prestataire (numéro SIRET).
        </li>
        <li>
          À chaque facture, vous ne payez que <strong>50 %</strong>. L'URSSAF
          règle le solde directement à l'artisan.
        </li>
      </ol>

      <h2>Exemple concret en Creuse</h2>
      <div className="callout">
        <strong>Cas pratique</strong>
        Mme M. à Guéret fait tondre son jardin 12 fois dans l'année et tailler ses
        haies une fois par trimestre — <strong>1 600 € TTC</strong> de
        prestations sur l'année. Avec l'avance immédiate, elle ne décaisse que{" "}
        <strong>800 €</strong>. Le reste (800 €) est pris en charge directement
        par l'URSSAF. Aucune avance de trésorerie, aucune attente.
      </div>

      <h2>Quels documents fournir ?</h2>
      <ul>
        <li>Une <strong>facture détaillée</strong> du prestataire avec son numéro d'agrément SAP</li>
        <li>L'<strong>attestation fiscale annuelle</strong> à conserver (envoyée automatiquement)</li>
        <li>Votre <strong>déclaration de revenus</strong> en case 7DB si vous ne passez pas par l'avance immédiate</li>
      </ul>

      <h2>Comment vérifier que votre paysagiste est agréé ?</h2>
      <p>
        Demandez son <strong>numéro d'agrément SAP</strong> (mentionné sur le
        devis et la facture) et vérifiez-le sur le portail officiel{" "}
        <a
          href="https://nova.entreprises.gouv.fr/nova/extranet/findOrganismes.html"
          target="_blank"
          rel="noopener noreferrer"
        >
          NOVA Entreprises
        </a>
        . Sans agrément, <strong>aucun crédit d'impôt</strong> n'est possible.
      </p>

      <h2>En résumé</h2>
      <p>
        Faire entretenir votre jardin par un professionnel agréé revient au
        final <strong>2 fois moins cher</strong> qu'on ne le croit. Vous gagnez
        du temps, votre extérieur reste impeccable toute l'année, et vous
        soutenez l'activité d'un artisan local. Découvrez{" "}
        <Link to="/entretien-jardin-creuse">notre offre entretien jardin en Creuse</Link>{" "}
        ou demandez un devis personnalisé en quelques clics.
      </p>
    </BlogPostLayout>
  );
}
